import { z } from "zod";
import { dmaFormulationDtoSchema } from "../dma-formulation";
import { dmaInitialGuessesHintDtoSchema } from "../dma-initial-guesses-hint";
export const dmaFormulationRequestDtoSchema = z.object({
    formulation: dmaFormulationDtoSchema,
    initialGuessesHint: z.optional(dmaInitialGuessesHintDtoSchema),
});
